const initialState = {};

export default (state=initialState, action) => {
	switch (action.type) {
    case 'SET_APPLICATION_SENT':      
      return {...state, applicationSent: action.applicationSent};
    case 'SET_VERIFICATION_QUESTIONS':
      return {...state, verificationQuestions: action.verificationQuestions};
    case 'SET_VERIFICATION_SENT':
      return {...state, verificationSent:action.verificationSent};
    case 'SET_APPLICATION_COMPLETE':
			return {...state, applicationComplete: action.applicationComplete};                  
    case 'SET_CURRENT_LOCATION':
      return {...state, currentLocation: action.currentLocation};          
    case 'SET_APPLICATION_ID':
      return {...state, visaApplicationId: action.visaApplicationId};        
    case 'SET_IS_MEMBER':
      return {...state, isMember: action.isMember};  
    case 'SET_AUTH_USER_SELECTED':
      return {...state, authUserSelected: true};  
    case 'SET_NUM_AUTH_USERS': 
      return {...state, authUsersNum: action.authUsersNum};  
    case 'SET_BPI_SELECTED':
      return {...state, bpiSelected: true};  
    case 'SET_BPI':
      return {...state, bpi: action.bpi};
		default: 
			return state			
	}
}


// WEBPACK FOOTER //
// ./src/reducers/applicationReducer.js